import { createFileRoute } from "@tanstack/react-router";
import { InvoiceForm } from "@/components/InvoiceForm";

export const Route = createFileRoute("/_auth/invoices/ar/new")({
  component: () => <InvoiceForm direction="ar" />,
});
